import { ComponentType, ReactNode } from 'react';

import { getPartnerConfig as getRobibetConfig, PartnerConfig } from '../robibet/config/routingConfig';
import { PartnerRoutingProvider as RobibetProvider } from '../robibet/context/PartnerRoutingContext';

/**
 * Global partner registry
 * Maps partner IDs to their respective configs from different partner directories
 */
export const getPartnerConfig = (partnerId: number): PartnerConfig | null => {
  // Check Robibet partners (IDs 1, 9)
  const robibetConfig = getRobibetConfig(partnerId);
  if (robibetConfig) {
    return robibetConfig;
  }

  // Future partners can be added here:
  // const otherPartnerConfig = getOtherPartnerConfig(partnerId);
  // if (otherPartnerConfig) return otherPartnerConfig;

  return null;
};

export const getPartnerProvider = (partnerId: number): ComponentType<{ children: ReactNode }> | null => {
  // Robibet partner (ID 9)
  if (partnerId === 9) {
    return RobibetProvider;
  }

  // Other partners would return their own providers here
  // if (partnerId === 10) return OtherPartnerProvider;

  return null;
};

export type { PartnerConfig };
